<template>
  <div class="order-manage-details orderBox">
    <a-card title="基本信息" :bordered="false">
      <a-skeleton :loading="loading" active>
        <div class="grids">
          <div>
            <span>订单编号:</span>
            <span>{{ data.sNo }}</span>
          </div>
          <div>
            <span>订单类型:</span>
            <span>{{ data.grText }}</span>
          </div>
          <div>
            <span>订单状态:</span>
            <span>{{ data.r_status }}</span>
          </div>
          <div>
            <span>配送费用:</span>
            <span v-if="data.freight > 0">{{ data.freight }}</span>
            <span v-else>免邮</span>
          </div>

          <div>
            <span>订单来源:</span>
            <span v-if="data.source == 1">微信小程序</span>
            <span v-else-if="data.source==2">App</span>
            <span v-else-if="data.source==3">支付宝小程序</span>
            <span v-else-if="data.source==4">头条小程序</span>
            <span v-else-if="data.source==5">百度小程序</span>
            <span v-else-if="data.source==6">pc端</span>
            <span v-else>H5移动端</span>
          </div>
          <div>
            <span>支付方式:</span>
            <span>{{ data.paytype }}</span>
          </div>
          <div>
            <span>下单时间:</span>
            <span v-if="data.add_time">{{ data.add_time }}</span>
            <span v-else>暂无</span>
          </div>
          <div>
            <span>付款时间:</span>
            <span v-if="data.pay_time">{{ data.pay_time }}</span>
            <span v-else>暂无</span>
          </div>

          <div>
            <span>发货时间:</span>
            <span v-if="data.deliver_time">{{ data.deliver_time }}</span>
            <span v-else>暂无</span>
          </div>
          <div v-if="data.otype != 'VI'">
            <span>快递单号:</span>
            
            <template v-if="data.Orderlist === '暂无'">
              <span>{{ data.Orderlist }}</span>
            </template>

            <template>
              <span v-for="(item,i) in data.Orderlist" :key="i">{{ item.num }} {{ item.kuaidi_name }}</span>
            </template>

          </div>
          <div v-if="data.otype != 'VI'">
            <span>收货时间:</span>
            <span v-if="data.arrive_time">{{ data.arrive_time }}</span>
            <span v-else>暂无</span>
          </div>
          <div>
              <span>会员ID:</span>
              <span>{{ data.user_id }}</span>
          </div>
          <div>
              <span>会员名称:</span>
              <span>{{ data.user_name }}</span>
          </div>
          <div>
              <span>订单备注:</span>
              <span>{{ data.remarks }}</span>
          </div>
        </div>
      </a-skeleton>

    </a-card>

    <template v-if="consigneeshow && data.otype != 'VI'">
      <a-divider />
      <a-card title="收货人信息" :bordered="false">

        <a-skeleton :loading="loading" active>
          <div class="useraddes">
            <div>
              <span>收货人:</span>
              <span>{{ data.name }}</span>
            </div>

            <div>
              <span>联系电话:</span>
              <span>{{ data.mobile }}</span>
            </div>

            <div>
              <span>收货地址:</span>
              <span>{{ data.address }}</span>
            </div>

            <div>
              <span>备注信息:</span>
              <span>{{ data.remarks }}</span>
            </div>
          </div>
        </a-skeleton>
      </a-card>
    </template>
	
    <a-divider />

    <a-card title="商品信息" :bordered="false">

      <a-table class="merchandise" :columns="columns" :dataSource="dataSource" :loading="loading" :pagination="false" style="margin: 40px 20px 0;">


        <span slot="name" slot-scope="text, record">
          <img class="nameimg" :src="record.pic" :alt="record.p_name">
          <span>{{ record.p_name }}</span>
        </span>

        <span slot="sumup" slot-scope="text, record, index">
          <div class="sumups" :style="{ height: heights }" v-if="index == 0">

            <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
              {{ userpar.z_price }}<br />
              <span class="small" v-if="(data.otype == 'GM' || data.otype == '') && Number(coupon_price)>0">(店铺优惠：{{coupon_price}})</span>
              <span class="small" v-if="(data.otype == 'GM' || data.otype == '') && discount_type">({{discount_type}}优惠：{{preferential_amount}})</span>
               <p v-if="grade_rate!=0"><span>会员折扣优惠：</span> <span>- ￥{{grade_rate_amount}}</span></p>
              <span class="small" v-else>(优惠金额：{{coupon_price}})</span>
            </div>
          </div>
        </span>

        <span slot="z_price" slot-scope="text, record">
          {{ imputedPrice(record) }}
        </span>

        <span slot="freight" slot-scope="text, record">

          <template v-if="record.freight">
            {{ record.freight }}
          </template>
          <template v-else>
            免邮费
          </template>
        </span>

      </a-table>

      <div class="note">
          <p><span>商品总价：</span> <span>￥{{goodsPrice.toFixed(2)}}</span></p>
          <p v-if="data.otype != 'VI'"><span>运费：</span> <span>￥{{all_freight.toFixed(2)}}</span></p>
          <p v-if="(data.otype == 'GM' || data.otype == '' || data.otype == 'VI') && Number(coupon_price)>0"><span>店铺优惠：</span> <span>- ￥{{coupon_price}}</span></p>
          <p v-if="(data.otype == 'GM' || data.otype == '' || data.otype == 'VI') && discount_type"><span>{{discount_type}}优惠：</span> <span>- ￥{{preferential_amount}}</span></p>
		  <p v-if="grade_rate!=0"><span>会员折扣：</span> <span>- ￥{{grade_rate_amount.toFixed(2)}}</span></p>
          <p v-if="data.otype != 'GM' && data.otype != '' && data.otype != 'VI'"><span>优惠金额：</span> <span>- ￥{{coupon_price}}</span></p>
          <p class="bold"><span>合计支付：</span> <span class="red">￥{{userpar.z_price}}</span></p>
      </div>


    </a-card>
  
	<div class="foot">
	  <a-button type="danger" class="btns" @click="onGoBack">取消</a-button>
	</div>
  
  </div>
</template>

<script>
  const columns = [
  {
    key: 'id',
    title: '商品名称',
    scopedSlots: { customRender: 'name' },
  },
  {
    key: 'size',
    title: '商品规格',
    dataIndex: 'size'
  },
  {
    key: 'p_id',
    title: '商品ID',
    dataIndex: 'p_id'
  },
  {
    key: 'p_price',
    title: '单价',
    dataIndex: 'p_price'
  },
  {
    key: 'num',
    title: '数量',
    dataIndex: 'num'
  },
  // {
  //   key: 'freight',
  //   title: '运费',
  //   scopedSlots: { customRender: 'freight' },
  // },
  {
    key: 'z_price',
    title: '小计',
    // dataIndex: 'p_price'
    scopedSlots: { customRender: 'z_price' }
  },
  // {
  //   key: 'sumup',
  //   title: '总金额',
  //   scopedSlots: { customRender: 'sumup' },
  // }
]
export default {
  data(){
    return {
      columns,
      dataSource: [],
      consigneeshow: true,
      loading: true,
      data: {},
      heights: '',
      userpar:{},
      coupon_price: 0,
	  preferential_amount: 0,
      all_freight: 0,
      goodsPrice: 0,
	  discount_type: '',
      grade_rate:0,
      grade_rate_amount: 0,
    }
  },
  watch:{
    dataSource:function(val){
      this.heights = val.length * 92 + 'px'
    }
  },
  mounted(){
    this.httpInits()
  },
  methods: {
	  /**
	  * @name 返回
	  * */ 
	  onGoBack(){
	    this.$router.go(-1)
	  },
    /**
     * @name 初始页面数据
     */
    httpInits(){
      let { params } = this.$route
      this.$request.get('?module=pc_api&action=order&m=detail',{ params }).then(res => {

        let { code, message, data } = res
        if(code === 200){

          Object.assign(this,{
            dataSource: data.detail,
            userpar: data.detail[0],
            coupon_price: data.coupon_price,
            preferential_amount: data.preferential_amount,
			discount_type: data.discount_type,
            grade_rate: data.grade_rate,
            grade_rate_amount: data.grade_rate_amount,
          })
          data.detail.map( item =>{
            this.goodsPrice += parseFloat(item.p_price)* parseInt(item.num)
            this.all_freight += parseFloat(item.freight)
          })


          this.isState(data.data)

          setTimeout(() => {
            this.loading = false
          },600)
        }

      })
    },
    /**
     * @name 订单状态判断
     */
    isState(data){
      // status01: 6|已关闭 2|待收货
      let { status01 }  = data

      const State = (code) => {
        const status = new Map([
          ['0', true],
          ['1', true],
          ['2', true],
          ['3', true],
          ['4', true],
          ['5', true],
          ['6', false],
          ['7', true],
          ['8', true],
          ['9', true],
          ['10', true],
        ])
        return status.get(code)
      }


      this.isOrderType(data)
      this.getOrderCode(data)

      Object.assign(this,{
        consigneeshow: State(status01),
        data: data
      })
    },
    /**
     * @name 判断订单类型
     */
    isOrderType(data){
      if(data.otype == 'pt'){
        data.grText = '拼团订单'
      } else if(data.otype == 'JP'){
        data.grText = '竞拍订单'
      } else if(data.otype == 'integral'){
        data.grText = '积分订单'
      } else if(data.otype == 'VI') {
        data.grText = '虚拟订单'
      }else {
        if(data.drawid > 0){
          data.grText = '抽奖订单'
        } else {
          data.grText = '正价订单'
        }
      }
    },
    /**
     * @name 总价计算
     */
    imputedPrice(record){
      let { num, p_price, freight } = record
      // return round(parseFloat(p_price) * Number(num),2)
      return (parseFloat(p_price) * Number(num) + parseFloat(freight)).toFixed(2)
    },
    /**
     * @name 获取订单编号
     */
    getOrderCode(data){
      if(data.fh == 0){
        data.Orderlist = '暂无'
      } else {
        data.Orderlist = data.courier_num
      }
    }
  }
}
</script>

<style lang="less">
	.orderBox{
		overflow: auto;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		
		.foot{
			position: sticky;
			bottom: 0;
			z-index: 9;
			height: 68px;
			min-height: 68px;
			border-top: 1px solid #e9ecef;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			padding: 0px 60px;
			background: #ffffff;
		}
		
		.grids {
		  padding: 40px;
		  display: grid;
		  grid-template-columns: repeat(4, 1fr);
		  grid-gap: 30px;
		
		  div {
		    span:nth-child(even){
		      color: #323544;
		      font-size: 14px;
		    }
		
		    span:nth-child(odd){
		      color: #828B97;
		      font-size: 14px;
		    }
		  }
		}
		
		.useraddes {
		  padding: 40px;
		  height: 200px;
		  display: flex;
		  flex-direction: column;
		  justify-content: space-between;
		  font-size: 14px;
		  div {
		    span:nth-child(even){
		      color: #323544;
		      font-size: 14px;
		    }
		
		    span:nth-child(odd){
		      color: #828B97;
		      font-size: 14px;
		    }
		  }
		}
		
		.takedata {
		  padding: 40px;
		}
		
		.nameimg {
		  width:60px;
		  height:60px;
		}
		
		.ant-card-wider-padding .ant-card-head{
			position: sticky;
			top: 0;
			background-color: #FFFFFF;
			z-index: 8;
		}
		
		.sumups {
		  position: absolute;
		  top: 54px;
		  background: #ffffff;
		  width: 7.2%;
		  display: flex;
		  align-items: center;
		}
		  .small{
		    font-size: 12px !important;
		    color: #999!important;
		  }
		
		.note {
		  width: 200px;
		  float: right;
		  margin-top: 20px;
		  margin-right: 20px;
		
		  p {
		    display: flex;
		    justify-content: space-between;
		    font-size: 14px;
		  }
		
		  p.bold {
		    font-weight: bold;
		
		    .red {
		      color: red;
		    }
		  }
		}
	}
	
	.ant-divider-horizontal{
		min-height: 1px;
	}
</style>